/**
 * Given an iterable of promises, settles them one at a time.
 * If all of them resolve, returns the list of values.
 * If one of them rejects, provides a callback for reverting the
 * preceding (already resolved) values.
 */
export async function pTransaction(promises, rollback) {
    const results = [];
    for (const promise of promises) {
        try {
            results.push(await promise);
        }
        catch (err) {
            // eslint-disable-next-line @typescript-eslint/await-thenable
            await Promise.allSettled(results.map((r) => rollback(r)));
            throw err;
        }
    }
    return results;
}
//# sourceMappingURL=pTransaction.js.map